import { motion } from 'framer-motion';
import './About.css';
import React from 'react';
import { Col, Container,  Row, Image, Button } from 'react-bootstrap';
import belu from '../../Assets/belu.png';
import { useInView } from 'react-intersection-observer';
import { useTranslation } from 'react-i18next';


const About = () => {





    const { ref, inView } = useInView({
        trigger: 'once',
      });
    
      const animationVariants = {
        visible: { opacity: 1, scale: 1 },
        hidden: { opacity: 0, scale: 0.5 },
      };
    const { t } = useTranslation();

    const { i18n } = useTranslation();
    
      const changeLanguage = (language) => {
        i18n.changeLanguage(language);
      };


    return (
        <Container>
            <Row className='about' id='About'>
                <Col>
                    <hr className='linea'></hr>
                    <h1 className='about'>{t('ABOUT ME')}</h1>
                </Col>
            </Row>

   
                <Row className='me'>
                    <Col xxl={4} xl={5} lg={5} md={11} sm={11} className='contieneImgPro'>
                    <motion.img 
                    className='fotoBel'
                        fluid src={belu}
                        ref={ref}
                        initial="hidden"
                        animate={inView ? "visible" : "hidden"}
                        variants={animationVariants}
                        transition={{ duration: 1, reset: true }}  />
                       
                    </Col>
                    
                    <Col xxl={5} xl={6} lg={6} md={11} sm={11} className='contieneBelu'>
                        <p className='textBelu'>{t("I'm Belu, a frontend developer with a strong desire to learn. I consider myself an enthusiastic and committed individual to my personal and professional growth. Moreover, I'm proactive, results-oriented, and possess a creative mindset to tackle challenges. I'm always on the lookout for opportunities to learn and grow, and I easily adapt to new environments and technologies. I enjoy collaborating with other professionals and contributing to the success of the team. Continuously, I'm seeking new ways to improve and enhance my skills.")}</p>
                    </Col>

         
                </Row>

        </Container>
    );
}

export default About;